import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {OrganizationData} from '../../api/user-info-model';
import {UserInfoService} from '../../api/user-info.service';
import {FilterStorageService} from '../../services/filter-storage.service';

@Component({
  selector: 'app-organization-filter',
  templateUrl: './organization-filter.component.html',
  styleUrls: ['./organization-filter.component.scss']
})
export class OrganizationFilterComponent implements OnInit {
  @Output()
  filtersChanged: EventEmitter<boolean> = new EventEmitter<boolean>();

  organizations: OrganizationData[] = [];
  selectedOrganization: OrganizationData = null;

  constructor(private userInfoService: UserInfoService,
              private filterStorage: FilterStorageService) { }

  async ngOnInit() {
    const user = await this.userInfoService.get().toPromise();
    this.organizations = user.allowedOrganizations;

    const selectedOrganization = this.tryToFindSelectedOrganization(this.organizations);
    if (selectedOrganization == null) {
      this.changeLocation(user.defaultOrganizationId);
    } else {
      this.selectedOrganization = selectedOrganization;
    }
  }

  tryToFindSelectedOrganization(organizationList: OrganizationData[]) {
    const organization = this.filterStorage.getSelectedOrganization();

    if (organization == null) { return null; }

    if (organizationList.filter(o => o.id === organization.id).length > 0) {
      return organization;
    }

    return null;
  }

  changeLocation(organizationId: string) {
    const organization = this.organizations.filter(o => {
      return o.id === organizationId;
    })[0];

    this.filterStorage.saveSelectedOrganization(organization.id, organization.name);
    this.selectedOrganization = organization;

    this.emitEvent();
  }

  private emitEvent() {
    this.filtersChanged.emit(true);
  }
}
